import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AiService {

    private geminiUrl =
        'https://generativelanguage.googleapis.com/v1/models/gemini-2.5-flash:generateContent?key=AIzaSyAQkHOB5YEB4WSWERellqmNpY47L9c9wQc_';

    private ollamaUrl = 'http://192.168.10.15:11434/api/generate';

    constructor(private http: HttpClient) { }

    generarTexto(prompt: string): Observable<any> {

        // ================
        // 1. GEMINI
        // ================
        const bodyGemini = {
            contents: [
                { parts: [{ text: prompt }] }
            ]
        };

        return this.http.post(this.geminiUrl, bodyGemini).pipe(

            catchError(errGemini => {
                console.warn('Gemini falló → usando Ollama', errGemini);

                // ================
                // 2. OLLAMA LOCAL
                // ================
                const bodyOllama = {
                    model: 'llama3.1:8b',
                    prompt: prompt,
                    stream: false
                };

                return this.http.post(this.ollamaUrl, bodyOllama);
            })
        );
    }

    // Extrae el texto de la respuesta según la fuente
    extraerTexto(response: any): string {
        // Respuesta de Gemini
        if (response?.candidates?.[0]?.content?.parts?.[0]?.text) {
            return response.candidates[0].content.parts[0].text;
        }
        // Respuesta de Ollama
        if (response?.response) {
            return response.response;
        }
        return '';
    }
}